<template>
  <a-modal
    :title="currTitle"
    :width="450"
    :visible="visible"
    :closable="false"
    :maskClosable="closable">

    <template slot="footer">
      <a-button  @click="close">关闭</a-button>
      <a-button type="primary" @click="selectOk">确认</a-button>
    </template>

    <a-form>
      <a-form-item :labelCol="{span:4}" :wrapperCol="{span:20}" style="margin-bottom:10px" >
        <!-- <strong >当前所属租户：</strong>
        <strong style="color: blue;">{{ currentTenantName }}</strong></br> -->
        <strong >当前所属中心：</strong>
        <strong style="color: blue;">{{ currentCenterName }}</strong>
        <!-- <a-select @change="handleTenantChange"  placeholder="请选择租户" style="margin-left:10px;width: 80%">
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option v-for="t in tenantList" :key="t.id" :value="t.id">
            {{ t.name }}
          </a-select-option>
        </a-select> -->

        <a-select @change="handleCenterChange"  v-model="centerId" placeholder="请选择中心" style="margin-left:10px;width: 80%">
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option v-for="c in centerList" :key="c.id" :value="c.id">
            {{ c.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

    </a-form>


  </a-modal>

</template>

<script>
  import { getAction,putAction } from '@/api/manage'
  import Vue from 'vue'
  import store from '@/store/'
  import { USER_INFO } from "@/store/mutation-types"

  export default {
    name: 'CenterSelect',
    props: {
      gotopage: {
        type: String,
        default: '/pad/index'
      },
    },    
    data(){
      return {
        currTitle:this.title,
        visible:false,
        closable:false,
        tenantList:[],
        centerList:[],
        tenantId:'',
        centerId:'',
        userId:'',
        currentTenantName:'',
        currentCenterName:'',
      }
    },
    created(){
      //this.loadData()
    },
    mounted() {
      console.log('gotopage received:', this.gotopage); // 调试用
    },
    methods:{
      loadData(){
        return new Promise(resolve => {
          let url = "/sys/tenant/getList"
          getAction(url).then(res=>{
            if(res.success){
              this.tenantList=res.result
              let user = Vue.ls.get(USER_INFO)
              let currentTenant= this.tenantList.find(item=>item.id==user.tenantId)
              this.currentTenantName=currentTenant.name
              let currentCenter= currentTenant.centers.find(item=>item.id==user.centerId)
              this.currentCenterName=currentCenter.name
              this.handleTenantChange(currentTenant.id)
            }else{

            }
            resolve()
          })
        })
      },
      close(){
        this.clear()
      },
      clear(){
        this.centerList = []
        this.tenantList = []
        this.visible=false
        this.tenantId=''
        this.centerId=undefined
        this.currentTenantName=''
        this.currentCenterName=''
      },
      selectOk(){
        console.log('切换中心：',this.centerId)
        this.tenantResolve().then(()=>{
          this.$store.dispatch('saveTenant', this.tenant_id);
          this.$emit('success')
          this.visible=false
          this.$message.success('操作成功')
          console.log("----切换中心跳转---")
          this.$router.push({ path: this.gotopage }).catch(() => {
            console.log('租户切换跳转首页出错,这个错误从哪里来的')
          })
          window.location.reload(true)
        }).catch(err =>{
          console.log(err.message)
          this.$message.warning(err.message)
        })
      },
      tenantResolve(){
        return new Promise((resolve, reject)=>{ 
          if(!this.centerId || this.centerId=='' || this.centerId==undefined){
            // this.$message.warning('请选择中心')
            return reject(new Error('请选择中心'))         
          }         
            let user = {
              id:this.userId,
              centerId:this.centerId,
              tenantId:this.tenantId
            }            
            putAction("/sys/user/editWithTenant",user).then(res=>{
              if(res.success){
                let userInfo = Vue.ls.get(USER_INFO)
                userInfo.centerId = user.centerId
                userInfo.tenantId = user.tenantId
                Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
                this.$store.commit('SET_INFO', userInfo);
                resolve();
              }else{
                this.requestFailed(res)
                this.$store.dispatch('Logout');
                reject();
              }
            })
        })
      },
      show(){
        // this.visible=true
        this.clear();
        //loadData
        this.loadData().then(()=>{
          this.visible=true
        })
      },
      handleTenantChange(e){
        this.tenantId=e;
        this.tenantList.find(item=>{
          if(item.id==e){
            this.centerList = item.centers
            getAction("/project/center/userCenterList").then((res) => {
              let centers = []
              if (res.success) {
                this.centerList.forEach(center => {
                  if(res.result.some(i => i.id === center.id)){
                    centers.push(center)
                  }                  
                })                               
              }
              this.centerList = centers
            })
            return true
          }
        })
      },
      handleCenterChange(e){
        this.centerId=e;
        let user = Vue.ls.get(USER_INFO)

        // user.centerId = this.centerId
        // user.tenantId = this.tenantId
        this.userId=user.id        
      }
    }

  }
</script>
<style scoped>
  .valid-error .ant-select-selection__placeholder{
    color: #f5222d;
  }
</style>